export const newsData = {
    "2025": [
      {
        "url": "https://www.prnewswire.com/news-releases/sendbird-introduces-trust-os-for-ai-agents-to-deliver-enterprise-ready-controls-for--safer-smarter-customer-interactions-302517296.html",
        "title": "Sendbird Introduces Trust OS for AI Agents to Deliver Enterprise-Ready Controls for Safer, Smarter Customer Interactions | PR Newswire"
      },
      {
        "url": "https://www.prnewswire.com/news-releases/sendbird-appoints-charles-studt-as-chief-marketing-officer-to-advance-companys-ai-innovation-and-global-reach-302507562.html",
        "title": "Sendbird Appoints Charles Studt as Chief Marketing Officer to Advance Company's AI Innovation and Global Reach | PR Newswire"
      },
      {
        "url": "https://www.anthropic.com/customers/sendbird",
        "title": "Sendbird delivers reliable, enterprise-grade AI customer service with Claude | Anthropic"
      },
      {
        "url": "https://finance.yahoo.com/news/sendbird-launches-first-omnipresent-ai-130000522.html",
        "title": "Sendbird Launches First Omnipresent AI Agent, Marking Shift From Reactive to Proactive Customer Support | Yahoo Finance"
      },
      {
        "url": "https://siliconangle.com/2025/04/30/sendbird-launches-omnipresent-proactive-customer-support-ai-agent/",
        "title": "Sendbird launches omnipresent proactive customer support AI agent | SiliconANGLE"
      }
    ],
    "2024": [
        {
          "url": "https://www.prweb.com/releases/sendbird-launches-business-messaging-to-empower-teams-and-systems-to-send-critical-messages-with-impact-and-cost-effectiveness-302109846.html",
          "title": "Sendbird Launches Business Messaging to Empower Teams and Systems to Send Critical Messages with Impact and Cost-Effectiveness | PRWeb"
        },
        {
            "url": "https://www.kedglobal.com/korean-startups/newsView/ked202401030005",
            "title": "Sendbird aims to fly even higher, above 300 million | The Korea Economic Daily Global Edition"
        },
        {
            "url": "https://finance.yahoo.com/news/sendbird-unveils-easy-ai-chatbot-000000142.html",
            "title": "Sendbird Unveils Easy-to-Use AI Chatbot Tailored for Small Businesses | Yahoo Finance"
        },
        {
            "url": "https://www.prnewswire.com/apac/news-releases/sendbird-launches-ai-chatbot-powered-salesforce-connector-302052781.html",
            "title": "Sendbird Launches AI Chatbot-powered \"Salesforce Connector\" | PR Newswire"
        },
        {
            "url": "https://www.prweb.com/releases/sendbird-introduces-a-no-code-ai-chatbot-to-help-smbs-automate-customer-interactions-302072384.html",
            "title": "Sendbird Introduces a No-code AI Chatbot to Help SMBs Automate Customer Interactions | PRWeb"
        }
    ],
    "2023": [
        {
          "url": "https://www.destinationcrm.com/Articles/CRM-News/CRM-Across-the-Wire/Sendbird-Integrates-Metas-Llama-2-LLM-into-Its-Communications-Platform-161067.aspx",
          "title": "Sendbird Integrates Meta's Llama 2 LLM into Its Communications Platform | Destination CRM"
        },
        {
            "url": "https://www.destinationcrm.com/Articles/CRM-News/CRM-Across-the-Wire/Sendbird-Adds-SmartAssistant-to-Salesforce-Connector-160155.aspx",
            "title": "Sendbird Adds SmartAssistant to Salesforce Connector | Destination CRM"
        },
        {
            "url": "https://www.prweb.com/releases/sendbird-adds-ai-powered-smartassistant-to-salesforce-connector-for-fast-and-personalized-support-interactions-301904267.html",
            "title": "Sendbird Adds AI-Powered SmartAssistant to Salesforce Connector for Fast and Personalized Support Interactions | PRWeb"
        },
        {
            "url": "https://martechseries.com/analytics/data-management-platforms/privacy-and-regulations/sendbird-and-liveramp-partner-to-enable-marketers-to-personalize-every-experience-by-connecting-first-party-data-while-enhancing-privacy/",
            "title": "Sendbird and LiveRamp Partner to Enable Marketers to Personalize Every Experience | MarTech Series"
        },
        {
            "url": "https://www.prnewswire.com/apac/news-releases/sendbird-launches-smartassistant-the-first-no-code-generative-ai-chatbot-for-web-and-mobile-apps-301876151.html",
            "title": "Sendbird Launches SmartAssistant, the First No-Code Generative AI Chatbot for Web and Mobile Apps | PR Newswire"
        }
    ],
    "2022": [
        {
          "url": "https://www.destinationcrm.com/Articles/CRM-News/CRM-Across-the-Wire/Sendbird-Launches-Scheduled-Messages-and-Polls-156263.aspx",
          "title": "Sendbird Launches Scheduled Messages and Polls | Destination CRM"
        },
        {
            "url": "https://www.prweb.com/releases/2022/11/prweb19041594.htm",
            "title": "Sendbird Awarded 2022 Regional and Global AWS Partner Award | PRWeb"
        },
        {
            "url": "https://e27.co/reimagining-customer-experience-with-sendbird-20221103/",
            "title": "Reimagining customer experience with Sendbird | e27"
        },
        {
            "url": "https://techcrunch.com/2022/09/15/sendbird-adds-live-streaming-from-any-app-to-communications-platform/",
            "title": "Sendbird adds livestreaming from any app to communications platform | TechCrunch"
        },
        {
            "url": "https://www.forbes.com/sites/forbestechcouncil/2022/07/19/the-next-era-of-chat-elevating-engagement/?sh=7bfe1be56517",
            "title": "The Next Era Of Chat: Elevating Engagement | Forbes"
        }
    ],
    "2021": [
        {
            "url": "https://www.prweb.com/releases/sendbird_the_1_in_app_chat_api_debuts_new_features_while_making_enablement_for_developers_easier_than_ever/prweb18371217.htm",
            "title": "Sendbird, the #1 In-App Chat API, Debuts New Features | PRWeb"
        },
        {
            "url": "https://www.chosun.com/economy/tech_it/2021/04/06/4PV6UG6KJFDCTP3JRRWQUH423E/",
            "title": "The 12th unicorn… Messaging startup Sendbird raises $100M in funding | Chosun"
        },
        {
            "url": "https://platum.kr/archives/160778",
            "title": "Sendbird raises $100M funding… an enterprise software ‘unicorn’ is born | Platum Korea"
        },
        {
            "url": "https://www.businessinsider.com/sendbird-messaging-startup-raises-100-million-1-billion-valuation-2021-4",
            "title": "Exclusive look at the pitch deck messaging startup Sendbird used to raise $100 million | Business Insider"
        },
        {
            "url": "https://venturebeat.com/business/sendbird-secures-100m-to-help-businesses-add-chat-voice-and-video-calling-to-their-apps/",
            "title": "Sendbird secures $100M to help businesses add chat, voice, and video calling to their apps | VentureBeat"
        }
    ],
    "2020": [
        {
            "url": "https://appdevelopermagazine.com/Sendbird-opens-self-service-portal-for-sendbird-calls-apis/",
            "title": "Sendbird opens self-service portal for Sendbird calls APIs | App Developer Magazine"
        },
        {
            "url": "https://biz.chosun.com/site/data/html_dir/2020/04/08/2020040800059.html",
            "title": "‘유니콘 후보’도 전시 태세…센드버드 CEO ”코로나 불황 최소 18개월” | Chosun"
        },
        {
            "url": "http://ProgrammableWeb+|+April+3,+2020",
            "title": "Sendbird Adds Voice and Video Calling to its Portfolio of Communication APIs | ProgrammableWeb"
        },
        {
            "url": "https://www.theinvestor.co.kr/view.php?ud=20200402000529",
            "title": "SendBird acquires video conferencing platform Roundee.io | The Investor - APAC"
        },
        {
            "url": "https://m.theinvestor.co.kr/view.php?ud=20200326000994",
            "title": "SendBird boosts in-app API with voice, video functions | The Investor"
        }
    ],
    "2019": [
        {
            "url": "https://www.forbes.com/sites/forbestechcouncil/2019/09/12/what-we-can-learn-from-slack-and-its-long-term-prospects/?sh=5e5beedf4af3",
            "title": "[Contributed] What We Can Learn From Slack And Its Long-Term Prospects | Forbes"
        },
        {
            "url": "https://www.sportsbusinessjournal.com/Journal/Issues/2019/10/28/Opinion/Kim.aspx",
            "title": "[Contributed] Digital Stadiums: Winning the Game with Technology | Sports Business Journal"
        },
        {
            "url": "https://www.healthcarebusinesstoday.com/why-the-digitization-of-healthcare-should-give-us-hope/",
            "title": "[Contributed] Why the Digitization of Healthcare Should Give Us Hope | Healthcare Business Today"
        },
        {
            "url": "https://www.healthcarebusinesstoday.com/concierge-on-demand/",
            "title": "[Contributed] Concierge On Demand: How Messaging Technologies Can Transform the Administration of Benefits and Help Evolve the Healthcare Ecosystem | Healthcare Business Today"
        },
        {
            "url": "https://www.forbes.com/sites/forbestechcouncil/2019/08/05/are-super-apps-the-solution-to-the-service-conundrum-in-the-on-demand-economy/?sh=6bcddef0315d",
            "title": "[Contributed] Are Super Apps The Solution To The Service Conundrum In The On-Demand Economy? | Forbes"
        }
    ]
}